module.exports = __webpack_public_path__ + "media/images/icons/home_icon-9a02498ed2bf338a7734cb48fe069e99.svg";